export default "__VITE_ASSET__10w_Ajhk__"